import React, { useEffect, useMemo, useState } from 'react';

import TableComponent from 'app/components/TableComponent';
import { FormControl, InputGroup, Modal } from 'react-bootstrap-v5';
import './styles/abonos.css';
import { KTSVG } from '_metronic/helpers/components/KTSVG';
import { formatDecimal, toaster } from 'app/utilities/commons';
import {
  getAllBondsDepartment,
  updateBondDepartment,
} from 'app/service/asignacion_bonos/Asignacion_bonos';
import * as Yup from 'yup';
import axios from 'axios';
import { useFormik } from 'formik';
import { invalidChar } from 'app/utilities/invalidChar';
const API_URL = process.env.REACT_APP_API_NET;

type BondsDepartment = {
  bondId: number;
  periodId: number;
  periodDate: string;
  departmentName: string;
  bondAmount: number;
  bondPercent: number;
};

const BondsDepartmentSchema = Yup.object().shape({
  bondAmount: Yup.number()
    .required('Este campo es requerido.')
    .min(1, 'El monto debe ser mayor a 0'),
  bondPercent: Yup.number()
    .required('Este campo es requerido.')
    .min(0, 'El porcentaje debe ser mayor o igual a 0')
    .max(100, 'El porcentaje no puede ser mayor a 100'),
});

const heads = [
  { code: 'departmentName', label: 'Departamento' },
  { code: 'bondAmount', label: 'Bono General' },
  { code: 'bondPercent', label: 'Porcentaje' },
];

const Avieww: React.FC = () => {
  const [show, setShow] = useState(false);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [selectedDepartment, setSelectedDepartment] = useState<string>('');
  const [id, setId] = useState<number>();

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);
  const [bondsDepartment, setBondsDepartment] = useState<BondsDepartment[]>([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [loadingGrid, setLoadingGrid] = useState(true);
  const [nameDepartment, setNameDepartment] = useState('');
  const [isFiltered, setIsFiltered] = useState<boolean>(false);

  const formBondsDepartments = useFormik<any>({
    validationSchema: BondsDepartmentSchema,
    initialValues: {
      bondAmount: '',
      bondPercent: '',
    },
    onSubmit: async (values, { setSubmitting }) => {
      try {
        await updateBondDepartment(
          {
            ...values,
            bondId: id,
            bondAmount: values?.bondAmount,
            bondPercent: values?.bondPercent,
          },
          id
        );
        toaster.success('Se cambio con éxito la información');
        handleClose();
        fetchBondsDepartments();
      } catch (err) {
        console.error('Error', err);
      } finally {
        setSubmitting(false);
      }
    },
  });

  const fetchBondsDepartments = async () => {
    try {
      const res = await getAllBondsDepartment(currentPage, pageSize);
      setBondsDepartment(
        res.records.map((record) => ({
          ...record,
        }))
      );
      setTotalRecords(res.totalRecords);
      setLoadingGrid(false);
    } catch (err) {
      console.error('Error al obtener los Bonds Departments');
    }
  };

  const fetchBondsDepartmentsFilter = async (nameDepartment: any) => {
    setIsFiltered(true);
    try {
      const res = await getAllBondsDepartment(
        currentPage,
        pageSize,
        nameDepartment
      );
      console.log(res);
      setBondsDepartment(
        res.records.map((record) => ({
          ...record,
        }))
      );
      setTotalRecords(res.totalRecords);
      setLoadingGrid(false);
    } catch (err) {
      console.error('Error al obtener los Bonds Departments');
    }
  };

  const loadingInfo = async (bondId: number) => {
    try {
      const response = await axios.get(`${API_URL}BondsDepartment/${bondId}`);
      formBondsDepartments.setValues({
        bondAmount: response.data.data.bondAmount || '',
        bondPercent: response.data.data.bondPercent || '',
      });
      setSelectedDepartment(response.data.data.departmentName);
      setId(response.data.data.bondId);
    } catch (error) {
      console.error('Error loading the info');
      throw error;
    }
  };

  useEffect(() => {
    if(isFiltered){
      fetchBondsDepartmentsFilter(nameDepartment);
    }else{
      fetchBondsDepartments();
    }
  }, [currentPage, pageSize, isFiltered]);

  const rows = useMemo(() => {
    if (!loadingGrid && bondsDepartment.length) {
      return bondsDepartment.map((row) => ({
        departmentName: (
          <div
            onClick={() => {
              handleShow(row.departmentName);
              loadingInfo(row.bondId);
            }}
            className='text-info'
            style={{ textAlign: 'center', cursor: 'pointer' }}
          >
            {row.departmentName}
          </div>
        ),
        bondAmount: (
          <div style={{ textAlign: 'center' }}>
            ${formatDecimal.format(row.bondAmount)}
          </div>
        ),
        bondPercent: (
          <div style={{ textAlign: 'center' }}>{row.bondPercent}%</div>
        ),
      }));
    }
    return [];
  }, [bondsDepartment, loadingGrid]);

  const handleShow = (departmentName: string) => {
    setSelectedDepartment(departmentName);
    setShow(true);
  };

  const handleClose = () => {
    setShow(false);
  };

  const handleFilterOpen = () => {
    setShowFilterModal(true);
  };

  const handleFilterClose = () => {
    setShowFilterModal(false);
  };

  return (
    <div className="row gy-5 g-xl-8">
      <div className="col-xxl-12 col-xl-12 col-md-12 col-lg-12">
        <div className="card card-flush p-5">
          <div className="d-flex justify-content-between align-items-center mb-5">
            <h3 className="fw-bold fs-4">Tabla de Bonos</h3>

            <button
              className="btn btn-light-primary border-btn w-10"
              onClick={handleFilterOpen}
            >
              <KTSVG
                path="/media/icons/duotune/general/gen021.svg"
                className="svg-icon-5 svg-icon-gray-500"
              />
              <span className="ms-2">Filtrar</span>
            </button>

          </div>
          <TableComponent
            heads={heads}
            rows={rows}
            rowsPerPage={pageSize}
            page={currentPage}
            totalRows={totalRecords}
            setPage={setCurrentPage}
          />
        </div>

      </div>

      {/* Modal para asignar bono */}
      <Modal
        id="kt_modal_create"
        tabIndex={-1}
        aria-hidden="true"
        dialogClassName="modal-dialog"
        show={show}
        onHide={handleClose}
      >
        <div className="modal-content">
          <div className="modal-header">
            <h2 className="text-muted">Asignar Bono</h2>
            <div
              className="btn btn-sm btn-icon btn-active-color-primary"
              onClick={handleClose}
            >
              <KTSVG
                className="svg-icon-2"
                path="/media/icons/duotune/arrows/arr061.svg"
              />
            </div>
          </div>
          <div className="modal-body mx-5 padding-top-00">
            <form
              className="form needs-validation"
              noValidate
              onSubmit={formBondsDepartments.handleSubmit}
            >
              <div className="mb-3">
                <label className="form-label">Departamento</label>
                <input
                  type="text"
                  className="form-control"
                  value={selectedDepartment}
                  disabled
                />
              </div>
              <div className="mb-3">
                <div className="input-group">
                  <label htmlFor="bono" className="form-label">
                    Monto
                  </label>
                  <InputGroup>
                    <InputGroup.Text>$</InputGroup.Text>
                    <FormControl
                      type="number"
                      id="bono"
                      name="bondAmount"
                      value={formBondsDepartments.values.bondAmount}
                      onChange={formBondsDepartments.handleChange}
                      placeholder="Ingrese monto"
                      required
                      isInvalid={!!formBondsDepartments.errors.bondAmount}
                      onKeyDown={invalidChar}
                    />
                    {formBondsDepartments.touched.bondAmount &&
                      formBondsDepartments.errors.bondAmount && (
                        <div className="fv-plugins-message-container text-danger w-100">
                          <span role="alert">
                            {formBondsDepartments.errors.bondAmount}
                          </span>
                        </div>
                      )}
                  </InputGroup>
                </div>
              </div>
              <div className="mb-3">
                <label htmlFor="porcentaje" className="form-label">
                  Porcentaje
                </label>
                <InputGroup>
                  <FormControl
                    type="number"
                    id="porcentaje"
                    name="bondPercent"
                    value={formBondsDepartments.values.bondPercent}
                    onChange={formBondsDepartments.handleChange}
                    placeholder="Ingrese porcentaje"
                    required
                    isInvalid={!!formBondsDepartments.errors.bondPercent}
                    onKeyDown={invalidChar}
                  />
                  <InputGroup.Text>%</InputGroup.Text>
                  <FormControl.Feedback type="invalid">
                    {formBondsDepartments.errors.bondPercent}
                  </FormControl.Feedback>
                </InputGroup>
              </div>
              <div className="d-flex justify-content-between mt-4">
                <button
                  type="button"
                  className="btn btn-secondary me-2"
                  onClick={handleClose}
                >
                  Cancelar
                </button>
                <button type="submit" className="btn btn-primary">
                  Asignar
                </button>
              </div>
            </form>
          </div>
        </div>
      </Modal>

      {/* Modal del Filtro */}
      <Modal
        id="kt_modal_filter"
        tabIndex={-1}
        aria-hidden="true"
        dialogClassName="modal-dialog"
        show={showFilterModal}
        onHide={handleFilterClose}
      >
        <div className="modal-content">
          <div className="modal-header">
            <h1 className="text-muted mx-5">Filtrar Resultados</h1>
            <div
              className="btn btn-sm btn-icon btn-active-color-primary"
              onClick={handleFilterClose}
            >
              <KTSVG
                className="svg-icon-2"
                path="/media/icons/duotune/arrows/arr061.svg"
              />
            </div>
          </div>
          <div className="modal-body mx-5 padding-top-00">
            <div className="mt-4">
              <label className="form-label fw-bold">Departamento: </label>
            </div>
            <div>
              <input
                type="text"
                value={nameDepartment}
                className="form-control mt-4"
                data-kt-element="input"
                onChange={(e) => {
                  setNameDepartment(e.target.value);
                }}
              />
            </div>
            <div className="mt-4 d-flex flex-row-reverse">
              <button
                type="submit"
                className="btn btn-primary"
                data-kt-menu-dismiss="true"
                onClick={(e) => {
                  e.preventDefault();
                  setCurrentPage(1);
                  fetchBondsDepartmentsFilter(nameDepartment);
                  handleFilterClose();
                }}
              >
                Buscar
              </button>
              <button
                type="reset"
                className="btn btn-white btn-active-light-primary me-2"
                data-kt-menu-dismiss="true"
                onClick={(e) => {
                  e.preventDefault();
                  handleFilterClose();
                  setNameDepartment('');
                  setCurrentPage(1);
                  setIsFiltered(false); 
                  fetchBondsDepartments();
                }}
              >
                Limpiar
              </button>
            </div>
            <div className="mt-4 d-flex flex-row-reverse"></div>
          </div>
        </div>
      </Modal>
      <div className="d-flex flex-row-reverse ">

      </div>
    </div>

  );
};

export { Avieww };
